import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const ProprietorshipRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Proprietorship Registration
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        Under the Companies Act, 2013, Section 8 Companies must comply with MCA
        (Ministry of Corporate Affairs) regulations, focusing on promoting
        activities like art, science, sports, commerce, and charity, without
        distributing profits or dividends.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Regulatory Context */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Regulatory Context
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Section 8 Companies, classified as Non-Governmental Organizations
            under the Companies Act, 2013, are mandated to adhere to MCA
            compliance. These entities focus on supporting underserved
            communities and sectors in India, operating as limited companies
            without the 'Limited' suffix in their names.
          </p>

          {/* Record-Keeping Duties */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Record-Keeping Duties
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Section 8 Companies must maintain statutory registers annually,
            documenting details of members, loans, charges, and investments to
            assess yearly performance. These records are critical for regulatory
            oversight and internal review.
          </p>

          {/* Financial Management */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Financial Management
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Annual financial statements, including trading accounts, profit and
            loss accounts, and balance sheets, must be prepared and submitted to
            the registrar. Additionally, a Director’s Report, filed via Form
            AOC-4 under Section 134, provides shareholders with insights into the
            company’s financial health and business scope.
          </p>

          {/* Auditor Responsibilities */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Auditor Responsibilities
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            It is mandatory for Section 8 Companies to appoint an auditor
            annually to oversee financial recordings. The auditor ensures
            accurate financial statements, with signed minutes of meetings
            maintained at the registered office for transparency.
          </p>

          {/* Meeting Schedules */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Meeting Schedules
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Board meetings must occur at least twice yearly for small companies,
            with no more than 90 days between sessions. The Annual General
            Meeting (AGM) is held by September 30th, requiring a 21-day notice,
            with attendance mandatory for directors, members, and auditors, and a
            report submitted via Form MGT-15 within 30 days.
          </p>

          {/* Tax Obligations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Tax Obligations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Section 8 Companies must file Income Tax Returns by September 30th of
            the following fiscal year. Registration under Sections 12A and 80G
            allows tax exemptions, provided conditions under Section 11 are met,
            using Forms 10A and 10B respectively.
          </p>

          {/* Event-Based Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Event-Based Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Event-based compliances are triggered by specific occurrences, such
            as share transfers, director appointments/resignations, or changes in
            the company’s name or structure. These non-periodic filings ensure
            timely updates to the MCA.
          </p>

          {/* Penalty Provisions */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Penalty Provisions
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Non-compliance may lead the MCA to revoke the company’s license if
            found operating fraudulently, impose fines from INR 10 lakhs to INR 1
            crore, or penalize directors with imprisonment or fines up to INR 25
            lakhs. Officers in default may face action under Section 447.
          </p>

          {/* Submission Deadlines */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Submission Deadlines
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Key deadlines include the AGM by September 30th, Form AOC-4 within 30
            days of the AGM, Form MGT-7 within 60 days of the AGM, and Income
            Tax Returns by September 30th. Adhering to these dates prevents
            penalties.
          </p>

          {/* Required Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Required Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Essential documents include the Memorandum of Association, Articles
            of Association, Digital Signature Certificate (DSC), and Certificate
            of Incorporation, ensuring all compliance filings are properly
            supported.
          </p>

          {/* Operational Procedures */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Operational Procedures
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Compliance involves regular maintenance of financial and statutory
            records, timely meeting conduct, and submission of returns. Proper
            execution of these procedures is vital to avoid legal repercussions
            and maintain operational continuity.
          </p>

          {/* Concluding Insights */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Insights
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Section 8 Company compliance is a critical obligation to uphold its
            charitable mission and legal standing. Adhering to MCA guidelines
            and deadlines ensures smooth operations and avoids severe penalties.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProprietorshipRegistration;